import React from 'react'
import { useSelector } from 'react-redux'

export default function useGameStage(tempTableId) {
    const gameStage = useSelector((state) => state.gameTable.games[tempTableId].gameStage);

    if (!gameStage) {
        return null
    }

    return gameStage;
}
